import { connect } from 'react-redux';
import { setCertShippingType } from '../store/certificate/slice';
import withMobile from '../hocs/withMobile';
import ShippingType from '../components/ShippingType';
import { SHIPPING_TYPES } from '../store/certificate/constants';
import { getCertShippingType } from '../store/certificate/selectors';

const mapStateToProps = (state) => ({
  deliveryMethods: SHIPPING_TYPES,
  value: getCertShippingType(state),
});

const mapDispatchToProps = (dispatch) => ({
  onChange: (payload) => dispatch(setCertShippingType(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(ShippingType));
